﻿import './recipeLanding.less'
import 'urlpattern-polyfill';

if (!globalThis.URLPattern) {
    const URLPatternPolyfill = await import("https://esm.sh/urlpattern-polyfill");
    globalThis.URLPattern = URLPatternPolyfill.URLPattern;
}


const init = () => {
    if (document.querySelectorAll(".grid-item")) {
        document.querySelectorAll(".grid-item a").forEach((item) => {
            item.addEventListener("click", (e) => {

                var _newUrl = e.currentTarget.getAttribute("href");
                var target = e.currentTarget.parentElement;

                if (target.getBoundingClientRect().y < parseInt(getComputedStyle(document.querySelector(".main-nav")).height)) {
                    e.preventDefault();
                    const offset = window.innerWidth > 768 ? 70 : 100;
                    gsap.to(window, {
                        duration: .5, scrollTo: { y: target, offsetY: offset }, onComplete: () => {
                            window.location.href = _newUrl;
                        }
                    });
                } 



            })
        });
    }
}

if (document.readyState !== 'loading') {
    init();
} else {
    document.addEventListener('DOMContentLoaded', function () {
        init();
    });
}



const basePath = '/recipes';
const overviewPagePattern = new URLPattern(`${basePath}`, window.origin);
const isOverviewPage = (url) => {
    return overviewPagePattern.exec(url);
}

const detailPagePattern = new URLPattern(`${basePath}/*`, window.origin);
const isDetailPage = (url) => {
    return detailPagePattern.exec(url);
}

window.addEventListener('pageswap', async (e) => {
    const currentUrl = e.activation.from?.url ? new URL(e.activation.from.url) : null;
    const targetUrl = new URL(e.activation.entry.url);
    if (currentUrl.pathname == "/recipes") {
        
        sessionStorage.setItem('scrollPosition', window.scrollY);
    }

    if (e.viewTransition) {
        // Where did we come from and where are we going to?

      
        // Only transition to same basePath
        // ~> SKIP!

        console.log("page swap recipe");
        if (!targetUrl.pathname.startsWith(basePath)) {
           // e.viewTransition.skipTransition();
           // console.log("page transition skip recipe");
        }

        // Going from overview page to detail page
        // ~> Set the type to â€œto-detailâ€
        // ~> Apply `.last-clicked` on the correct thumbnail so that the CSS can kick in



        if (isOverviewPage(currentUrl) && isDetailPage(targetUrl)) {
            // Set the proper view-transition-type
            e.viewTransition.types.add('to-detail');

            // Transform full path URL to only the filename
            const filename = targetUrl.pathname.replace(`${basePath}/`, '');
            // Find and manipulate the thumbnail
            const $link = document.querySelector(`.grid-item a[href="/recipes/${filename}"] .img-top-bg`);
            $link.classList.add('last-clicked');

            // Clean up afterwards
            await e.viewTransition.finished;
            $link.classList.remove('last-clicked');

            return;
        }

        // TODO: Going from detail page to overview
        // ~> Set the type to â€œto-overview
        if (isDetailPage(currentUrl) && isOverviewPage(targetUrl)) {
            e.viewTransition.types.add('to-overview');
           // sessionStorage.setItem('scrollPosition', window.scrollY);
           
            return;
        }
    }
});

window.addEventListener('pagereveal', async (e) => {

    // We need Navigation Activation Information
    if (!navigation.activation.from) return;

    const fromUrl = new URL(navigation.activation.from.url);
    const currentUrl = new URL(navigation.activation.entry.url);

    // There is an automatic viewTransition, so the user comes from the same origin

    if (e.viewTransition) {

        // Where did we come from and where are we going to?


        // Only transition to/from same basePath
        // ~> SKIP!
        if (!fromUrl.pathname.startsWith(basePath)) {
           // e.viewTransition.skipTransition();
        }

        // Going from overview page to detail page
        // ~> Set the type to â€œto-detailâ€
        if (isOverviewPage(fromUrl) && isDetailPage(currentUrl)) {
            e.viewTransition.types.add('to-detail');
            return;
        }

        // Going from overview page to detail page
        // ~> Set the type to â€œto-overviewâ€
        // ~> Apply `.last-clicked` on the correct thumbnail so that the CSS can kick in
        //console.log(isDetailPage(fromUrl), isOverviewPage(currentUrl));
        if (isDetailPage(fromUrl) && isOverviewPage(currentUrl)) {
            // Set the proper view-transition-type
            e.viewTransition.types.add('to-overview');

            // Transform full path URL to only the filename
            const filename = fromUrl.pathname.replace(`${basePath}/`, '');
            //console.log("page reveal file name:: ", filename);
            // Find and manipulate the thumbnail
            const $link = document.querySelector(`.grid-item a[href="/recipes/${filename}"] .img-top-bg`);
            $link.classList.add('last-clicked');

            // Clean up afterwards
            await e.viewTransition.ready;
            $link.classList.remove('last-clicked');
           // console.log("sessionStorage get ", sessionStorage.getItem("scrollPosition"));
            if (sessionStorage.getItem("scrollPosition")) {
                window.scrollTo(0, parseInt(sessionStorage.getItem("scrollPosition")));
                sessionStorage.removeItem('scrollPosition');
            }
            return;
        } 
    }

    // User comes from different origin or did a reload
    else {

        // Do a reload animation
        if (navigation.activation.navigationType == 'reload') {
            const t = document.startViewTransition({
                update: () => {
                    // NOOP
                },
                types: ['reload'],
            });
        }

        // @TODO: manually create a â€œwelcomeâ€ viewTransition here?
    }

});
